module.exports = {
    roles: [
        'Creative Technologist',
        'Interaction Designer',
        'Telecommunications Engineer',
    ],
    links: ['portfolio', 'contact'],
};



// WEBPACK FOOTER //
// ./content/pages/index.js